import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { SakuraFlower } from "./SakuraDecorations";

export default function StickyCta() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling 300px
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (!isVisible) return null;

  return (
    <aside
      aria-label="Hurtig kontakt"
      className="fixed bottom-4 right-4 z-40 sm:bottom-6 sm:right-6 transition-all duration-300 animate-in fade-in slide-in-from-bottom-3"
    >
      <div className="glass-dark text-white shadow-[0_12px_36px_rgba(89,52,39,0.35)] rounded-full p-1.5 sm:p-2 flex items-center space-x-2 border border-[#ffe0cf]/25">
        <a
          href="tel:29387186"
          className="flex items-center space-x-2 px-3.5 py-2 rounded-full bg-[#d74814] hover:bg-[#b83a0d] transition-colors text-xs sm:text-sm font-medium whitespace-nowrap focus:outline-none focus:ring-2 focus:ring-white shadow-xs"
          aria-label="Ring til Kita Akupunktur på 29 38 71 86"
        >
          <i className="fa-solid fa-phone text-xs text-[#ffe0cf]" aria-hidden="true" />
          <span className="hidden sm:inline">Ring</span>
          <span className="whitespace-nowrap font-sans font-semibold">29 38 71 86</span>
        </a>

        <Link
          to="/kontakt"
          className="flex items-center space-x-1.5 px-3.5 py-2 rounded-full bg-white/15 hover:bg-white/25 transition-colors text-xs sm:text-sm font-medium text-white focus:outline-none focus:ring-2 focus:ring-white group"
        >
          <SakuraFlower className="w-3.5 h-3.5 text-[#ffe0cf] transition-transform group-hover:rotate-45" />
          <span className="whitespace-nowrap">Bestil tid</span>
        </Link>
      </div>
    </aside>
  );
}
